<template>
  <div class="min-h-screen">
    <div class="flex items-center justify-center h-16 py-2 bg-dark-type-1">
      <router-link to="/">
        <img src="@/assets/img/logo.png" style="width: 160px" alt="Shuttlers" />
      </router-link>
    </div>
    <div class="flex flex-col items-center justify-center min-h-screen">
      <template v-if="! isSuccessful">
        <form class="w-full max-w-xs" @submit.prevent="resetPassword">
          <h2 class="text-2xl font-bold text-center text-dark-type-3">Create a new password</h2>
          <div
            class="mt-1 text-xs font-medium text-center text-dark-type-4"
          >Try using something you can easily remember</div>
          <div
            class="flex items-start w-full p-3 mx-auto my-5 bg-red-200 rounded-md"
            v-if="errorMessage"
          >
            <div class="text-sm font-medium text-red-500">{{ errorMessage }}</div>
          </div>
          <div class="mt-12">
            <div class="mt-2">
              <label class="text-xs font-medium" for="password">Password</label>
              <div class="relative mt-2">
                <input
                  v-model="$v.form.password.$model"
                  :type="showPassword ? 'text' : 'password'"
                  id="password"
                  class="w-full h-12 px-3 py-4 text-xs font-medium outline-none placeholder-label-type-1 bg-gray-type-6 focus:outline-none"
                />
                <div
                  class="absolute inset-y-0 right-0 flex items-center pr-2 text-xs font-medium cursor-pointer text-active"
                  @click="showPassword = !showPassword"
                >{{ showPassword ? 'Hide' : 'Show' }}</div>
              </div>
              <span
                class="text-xs text-red-400"
                v-if="!$v.form.password.required && $v.form.password.$error"
              >Please enter a password</span>
              <span class="text-xs text-red-400" v-if="!$v.form.password.minLength">
                Password must have at least
                {{ $v.form.password.$params.minLength.min }} characters.
              </span>
            </div>
            <div class="mt-2">
              <label class="text-xs font-medium" for="password">Confirm Password</label>
              <div class="relative mt-2">
                <input
                  v-model="$v.form.confirm_password.$model"
                  :type="showPassword ? 'text' : 'password'"
                  id="confirm-password"
                  class="w-full h-12 px-3 py-4 text-xs font-medium outline-none placeholder-label-type-1 bg-gray-type-6 focus:outline-none"
                />
                <span
                  class="text-xs text-red-400"
                  v-if="!$v.form.confirm_password.sameAsPassword"
                >Passwords must be identical.</span>
              </div>
            </div>
          </div>
          <button
            type="submit"
            class="block w-full h-12 py-4 mt-12 font-bold text-center text-white rounded focus:outline-none"
            :class="processing ? 'bg-gray-type-7' : 'bg-active'"
            :dislabed="processing"
          >{{ processing ? 'Processing...' : 'Set Password' }}</button>
        </form>
      </template>
      <template v-else>
        <div class="w-full max-w-md">
          <img
            src="@/assets/img/password-changed.svg"
            class="block mx-auto text-center"
            alt="Password changed"
          />
          <h2 class="mt-2 text-2xl font-bold text-center text-dark-type-3">Password changed</h2>
          <div
            class="mt-1 text-sm font-medium text-center text-dark-type-4"
          >You have successfully changed your password</div>
          <router-link
            to="/"
            class="block w-56 h-12 py-4 mx-auto mt-12 font-bold text-center text-white rounded bg-active"
          >Login</router-link>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import axios from "@/services/axios";
import { required, sameAs, minLength } from "vuelidate/lib/validators";

export default {
  props: ["token"],
  data() {
    return {
      isSuccessful: false,
      showPassword: false,
      processing: false,
      errorMessage: "",
      form: {
        password: "",
        confirm_password: "",
        type: this.$route.query.type,
        token: this.token
      }
    };
  },
  validations: {
    form: {
      password: {
        required,
        minLength: minLength(6)
      },
      confirm_password: {
        sameAsPassword: sameAs("password")
      }
    }
  },
  methods: {
    resetPassword() {
      this.$v.form.$touch();

      if (this.processing || this.$v.form.$error) {
        return;
      }

      this.processing = true;
      this.errorMessage = null;

      axios
        .post("/password/change", { ...this.form })
        .then(async () => {
          this.isSuccessful = true;
        })
        .catch(err => {
          this.isSuccessful = false;

          if (err.response && err.response.data.message) {
            this.errorMessage = err.response.data.message;
          } else {
            this.errorMessage = "Oops! An error occurred. Please try again.";
          }
        })
        .finally(() => (this.processing = false));
    }
  }
};
</script>